// Only explicitly audited, heavy description animations opt in.
// Keep their original animation and load shortly before the shopper reaches them.
const selector = 'img[data-fursera-media-src]';
const registered = new WeakSet();
function load(image) {
  const source = image.getAttribute('data-fursera-media-src');
  if (!source) return;
  image.loading = 'eager';
  const sourceSet = image.getAttribute('data-fursera-media-srcset');
  if (sourceSet) { image.srcset = sourceSet; image.removeAttribute('data-fursera-media-srcset'); }
  image.src = source;
  image.removeAttribute('data-fursera-media-src');
}
const observer = 'IntersectionObserver' in window
  ? new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        load(entry.target);
      }
    }, { rootMargin: '600px 0px' })
  : null;
function discover() {
  for (const image of document.querySelectorAll(selector)) {
    if (registered.has(image)) continue;
    registered.add(image);
    if (observer) observer.observe(image);
    else load(image);
  }
}
discover();
document.addEventListener('shopify:section:load', discover);
